import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Customs = ({list = {}, prefix = ''}) => (
  <Panes
    entity={list}
    prefix={prefix}
    panes={[
      {
        title: 'Customs Clearance',
        fields: [
          <TextField
            name="customs_address"
            prefix={prefix}
            label="Address"
            fieldProps={{multiline: true, rows: 4}}
          />,
        ]
      },
      {
        title: '',
        fields: []
      }
    ]}
    title=""/>
);

Customs.onSave = ({customs_address}) => ({customs_address});

export default Customs;
